import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllLogisticRequestById = createAsyncThunk(
    'logisticRequestSection/getAllLogisticRequestById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`logistic-request-service/v1/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetAllLogisticRequest = createAsyncThunk(
    'logisticRequestSection/getAllLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get('logistic-request-service/v1/get-all', params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const CreateLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/createLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('logistic-request-service/v1/create', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const UpdateLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/updateLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/update/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const DeleteLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/deleteLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`logistic-request-service/get-all-pageable-user/by-logistic-request-service-id/${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AssignLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/assignLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/assign/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AcceptLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/acceptLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/accept/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const RejectLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/rejectLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/reject/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const PreInTransitIssueLogisticRequest = createAsyncThunk(
    'logisticRequestSection/preInTransitIssueLogisticRequest',
    async (payload, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put('logistic-request-service/v1/pre-in-transit-issue', payload)
            .then((response) => response)
            .catch((error) => error.response);

        const { data, status } = result;
        return { data, status };
    },
);

export const InTransitLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/inTransitLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/in-transit/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const InTransitIssueLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/inTransitIssueLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/in-transit-issue/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const DeliverLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/deliverLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/deliver/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const CancelLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/cancelLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/cancel/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AddEmployeesVehiclesLogisticRequest  = createAsyncThunk(
    'logisticRequestSection/addEmployeesVehiclesLogisticRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`logistic-request-service/v1/add-employees-vehicles/`,params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

